import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faBell, faBars } from '@fortawesome/free-solid-svg-icons';
import { Bell, ChevronDown } from 'lucide-react';
import NotificationComponent from 'app/views/notification_component';
import { useNotifications } from 'app/contexts/NotificationContext';
import LanguageSelector from './Language';
import { getProsecutorDetailByEmployeeId } from 'app/apis/users';
import { useTranslation } from 'react-i18next';

export default function Header({ toggleSidebar }) {
    const { t } = useTranslation();
    const [showDropdown, setShowDropdown] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);
    const dropdownRef = useRef(null);
    const full_name = sessionStorage.getItem('full_name');
    const notificationRef = useRef(null);
    const { unreadCount } = useNotifications();
    const [error, setError] = useState("");
    const [userDetail, setUserDetail] = useState(null);

    const handleLogout = () => {
        sessionStorage.clear();
        window.location.reload();
    };

    const handleNotificationClick = () => {
        setShowNotifications(!showNotifications);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <header className="flex items-center justify-between bg-white shadow-sm p-2 md:p-4 w-full">
            {/* Mobile Menu Button and Logo */}
            <div className="flex items-center">
                <button
                    onClick={toggleSidebar}
                    className="md:hidden mr-2 text-gray-600 focus:outline-none"
                >
                    <FontAwesomeIcon icon={faBars} className="text-xl" />
                </button>

                <div className="flex items-center">
                    <div className="h-8 md:h-10 w-1 bg-red-600 mr-2 md:mr-3"></div>
                    <div className="flex flex-col">
                        <h1 className="text-lg md:text-xl font-bold text-gray-800">{t("Panel Discussion System")}</h1>
                        <p className="text-xs md:text-sm text-gray-600">{t("Panel Discussion Management System")}</p>
                    </div>
                </div>
            </div>

            {/* Right Side Content */}
            <div className="flex items-center space-x-4 md:space-x-6">
                {/* Global Icon - Hidden on small screens */}
                <LanguageSelector />

                {/* Notification Icon */}
                <div
                    className="relative cursor-pointer"
                    onClick={handleNotificationClick}
                    ref={notificationRef}
                >
                    <div className="relative">
                        <Bell className="text-gray-700" />
                        {unreadCount > 0 && (
                            <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                                {unreadCount > 9 ? '9+' : unreadCount}
                            </span>
                        )}
                    </div>

                    {/* Notification Dropdown */}
                    {showNotifications && (
                        <div className="absolute right-0 mt-2 w-72 sm:w-80 md:w-96 bg-white border border-gray-200 shadow-lg rounded-lg p-2 z-50">
                            <NotificationComponent
                                setNotificationCount={setNotificationCount}
                                initialCount={notificationCount}
                            />
                        </div>
                    )}
                </div>

                {/* Vertical Divider */}
                <div className="hidden md:block h-8 w-px bg-gray-300"></div>

                {/* User Profile Section */}
                <div className="flex items-center space-x-2 relative" ref={dropdownRef}>
                    <div className="hidden md:flex md:items-center md:space-x-2">
                        <FontAwesomeIcon
                            icon={faUserCircle}
                            className="text-gray-800 text-3xl"
                            style={{ fontSize: 32 }}
                        />
                        <div className="flex flex-col">
                            <p className="text-sm font-medium text-gray-800">{full_name}</p>
                            {/* <p className="text-xs text-gray-500">{userDetail?.job_position?.job_title}</p> */}
                        </div>
                    </div>

                    <button
                        onClick={() => setShowDropdown(!showDropdown)}
                        className="focus:outline-none"
                    >
                        <ChevronDown size={16} className="text-gray-600" />
                    </button>

                    {/* Dropdown Menu */}
                    {showDropdown && (
                        <div className="absolute right-0 top-12 mt-2 w-48 bg-white border border-gray-200 shadow-lg rounded-lg z-50">
                            <ul className="py-1">
                                <li
                                    className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-500 font-medium"
                                    onClick={handleLogout}
                                >
                                    {t("Logout")}
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
}